import script from "./Social.vue?vue&type=script&lang=ts&setup=true"
export * from "./Social.vue?vue&type=script&lang=ts&setup=true"

import "./Social.vue?vue&type=style&index=0&id=5d982432&lang=css"

const __exports__ = script;

export default __exports__